import React from 'react';
import { Theme } from '@mui/material/styles';
import useTheme from '@mui/material/styles/useTheme';

import makeStyles from '@mui/styles/makeStyles';
import SplitPageTitle from 'components/Layout/SplitPageTitle';
import DynamicCollection from 'components/Collection/DynamicCollection';
import { CGCardSize } from '../Product/CardMaster';
import useMediaQuery from '@mui/material/useMediaQuery';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

interface ExperienceCardsProps {
  title: string;
  subtitle?: string;
  collection?: string;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      margin: theme.spacing(4, 0),
      [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(5, 0),
      },
    },
  }),
  { name: 'CoporateCollectionScreen' },
);

const ExperienceCards: React.FC<ExperienceCardsProps> = ({ title, subtitle = '', collection }) => {
  const classes = useStyles();
  const theme = useTheme();
  const cardSize: CGCardSize = useMediaQuery(theme.breakpoints.down('md')) ? 'small' : 'medium';

  return (
    <div className={classes.root}>
      <SplitPageTitle title={title} subtitle={subtitle} fullWidth sx={{ paddingX: { xs: 3, sm: 5 }, marginBottom: 12 }} />
      {collection && (
        <Stack>
          <DynamicCollection handle={collection} cardSize={cardSize} title={''} padFirstAndLast />
        </Stack>
      )}

      <Stack alignItems="flex-end" sx={{ mt: 7, mb: 9 }}>
        <Typography variant="body1" sx={{ width: { md: '50%' }, px: { xs: 3, sm: 5 } }}>
          Featuring a combination of your favorite stores, there’s something for everyone. Multi-Choice gift cards contain no fees, 3-year expiry, and can be used in-store and online, making it the
          perfect gift.
        </Typography>
      </Stack>

      <Box sx={{ textAlign: 'center', marginTop: { xs: 8, sm: 5 }, marginBottom: { xs: 8, sm: 14 } }}>
        <Button
          component={RouterLink} // It is a link...
          to={'/landing/multi-choice-cards/'}
          size="large"
          color="secondary"
          variant="outlined"
          endIcon={<SendIcon />}
        >
          Shop Now
        </Button>
      </Box>
    </div>
  );
};

export default ExperienceCards;
